// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    myCommunityLenses: {
        id: "apps.membership.components.lensContainersDropdown.myCommunityLenses",
        description: "My community lenses.",
        defaultMessage: "My Community Lenses",
    },
    search: {
        id: "apps.membership.components.lensContainersDropdown.search",
        description: "Search.",
        defaultMessage: "Search...",
    },
    searchOrganizations: {
        id: "apps.membership.components.lensContainersDropdown.searchOrganizations",
        description: "Search organizations.",
        defaultMessage: "Filter Organizations...",
    },
});
